import { atom } from 'recoil'

export interface addAssignMemberModalType {
  isVisible: boolean
  onOkFunction?: Function
  onCancelFunction?: Function
  okButtonProps?: {
    type: 'default' | 'link' | 'text' | 'ghost' | 'primary' | 'dashed'
    danger: boolean
  }
}

const initAddAssignMemberModal: addAssignMemberModalType = {
  isVisible: false,
  onOkFunction: Function,
  onCancelFunction: Function,
  okButtonProps: { type: 'primary', danger: false },
}

const addAssignMemberModalAtom = atom({
  key: 'addAssignMemberModalAtom',
  default: initAddAssignMemberModal,
})

export default addAssignMemberModalAtom
